// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__29cg5","alertIcon":"ConfirmModal_alertIcon__3uN0i"};